import { Action } from 'widgets-for-react'
import * as Immutable from 'immutable';
import * as React from 'react'
import L, { LatLngLiteral, FitBoundsOptions } from 'leaflet';
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import { MapEntity, MapStyling, MapsState, SelectionStatusType, CategoriesList, SimpleList, PresentationState } from './maps_types';
import { gtmPush } from '../../helpers';


// setup
export const provider = new OpenStreetMapProvider();

export const distanceLimit = 2000 //in meters
export const boundsOptions: FitBoundsOptions = { padding: [0, 0] };

export var hoppinger : LatLngLiteral = { lat: 51.9242, lng: 4.4818, }
export var center_rotterdam : LatLngLiteral = { lat: 51.902802, lng: 4.460994, }

let randomGeo = (center:LatLngLiteral, radius) : LatLngLiteral => {
  var y0 = center.lat;
  var x0 = center.lng;
  var rd = radius / 111300;

  var u = Math.random();
  var v = Math.random();

  var w = rd * Math.sqrt(u);
  var t = 2 * Math.PI * v;
  var x = w * Math.cos(t);
  var y = w * Math.sin(t);

  return {lat: y + y0, lng:x + x0}
}

//Generate a number of mappoints
export function generateMapPoints(centerpoint:LatLngLiteral, distance:number, amount:number):LatLngLiteral[] {
  var mappoints:LatLngLiteral[] = [];
  for (var i=0; i<amount; i++) {
      mappoints.push(randomGeo(centerpoint, distance));
  }
  return mappoints;
}

export function generateMapEntity(centerpoint:LatLngLiteral, distance:number, amount:number):Immutable.List<MapEntity> {
  var mappoints:Immutable.List<LatLngLiteral> = Immutable.List();
  for (var i=0; i<amount; i++) {
    mappoints = mappoints.push(randomGeo(centerpoint, distance));
  }
  let res : Immutable.List<MapEntity> = Immutable.List<MapEntity>(mappoints.map(p => ({
    position:p,
    info_when_on_list:(e, presentation_mode:PresentationState) => 
    <MapListItem 
      title={`De Hypotheker Schiedam (${getDistance(p, centerpoint)})`}
      address="Broersvest 64, 3112 DG Schiedam" 
      phoneNumber="010-4731150" 
      presentationMode={presentation_mode.value.kind}
      websiteURL='#testURL'
    />,
    info_when_on_map:e => 
    <div className="map-modal">
      <h3 className="map-modal__title typo--m">
        De Hypotheker Rotterdam Blijdorp
      </h3>

      <div className="map-modal__address">
        Stadhoudersweg 69-71<br />
        3039 EA Rotterdam<br />
        <a className="map-modal__phone"
          href={`tel:010-7143210`}
          onClick={_ => {gtmPush({ category: 'Locator', action: 'Map telephone', label: 'De Hypotheker Rotterdam Blijdorp' })}}
        >010-7143210</a>
      </div>

      <a href="#" className="btn btn--secondary map-modal__link">
        Bekijk de website
      </a>
      {/* {`x:${p.lng}y:${p.lat}`} */}
    </div>,
    show_info_on_map:"on_click",
    icon:e => e.selection_status != "none" ? markerIconSelected : markerIcon,
    selection_status:"none"
  } as MapEntity)))
  return res;
}

export type PresentationValues = "show list and map" | "show map" | "show list"

export type MapListItemProps = {
  title:  string
  address: string
  phoneNumber: string
  presentationMode: PresentationValues
  websiteURL?: string
}

export function MapListItem(props: MapListItemProps) : JSX.Element {
  const mapClassName : string = props.presentationMode.replace(' ', '-');
  return <div className={`maplist-item maplist-item--${mapClassName}`}>
    <h3 className="maplist-item__title typo--m">
      { props.websiteURL ? 
        <a className="maplist-item__link" href={props.websiteURL} target='_blank' onClick={_ => {gtmPush({ category: 'Locator', action: 'List website', label: props.title })}}>
          {props.title}
          <svg className='maplist-item__icon icon--arrow-right' width='25px' height='14px' aria-hidden="true">
          <use xlinkHref='#icon--arrow' />
        </svg>
        </a> 
      : props.title 
      }
    </h3>

    <div className="maplist-item__text">
      <span className="maplist-item__address">{props.address}</span>
      <a 
        className="maplist-item__phone link"
        href={`tel:${props.phoneNumber}`}
        onClick={_ => {gtmPush({ category: 'Locator', action: 'List telephone', label: props.title })}}
      >{props.phoneNumber}</a>
  
    </div>
  </div>
}


export let update_selection_status = function(set_state:(_: Action<MapsState>) => void, data:CategoriesList | SimpleList, e:MapEntity, status:SelectionStatusType) { 
  let will_update = false
  let was_prev_e_list_hover_or_click = false
  if(data.kind == "list_category"){
    data.categories.forEach(c => {
      if(c.title == data.selected_category){
        c.entities.forEach(e1 => {
          if(are_cord_same(e1.position, e.position) && e1.selection_status != status){
            was_prev_e_list_hover_or_click = e1.selection_status == "selected_in_list" || e1.selection_status == "hovered_in_list"
            will_update = true
          }
        }) 
      }
    })
  }else{
    data.entities.forEach(e1 => {
      if(are_cord_same(e1.position, e.position) && e1.selection_status != status){
        was_prev_e_list_hover_or_click = e1.selection_status == "selected_in_list" || e1.selection_status == "hovered_in_list"
        will_update = true
      }
    }) 
  }

  if(!will_update) return

  set_state(s => {
    let s1 = {...s, internal_cluster_key:status == "selected_in_list" || status == "hovered_in_list"|| (status == "none" && was_prev_e_list_hover_or_click) 
      ? s.internal_cluster_key + 1 
      : s.internal_cluster_key}
    if(s1.data_to_display.kind == "simple_list"){
      let entities = s1.data_to_display.entities.map(e1 => are_cord_same(e.position, e1.position) 
        ? {...e1, selection_status:status} 
        : status == "selected_in_list" || status == "selected_on_map" 
          ? {...e1, selection_status:"none" as "none"}
          : {...e1, selection_status: e1.selection_status == "selected_in_list" || 
                                      e1.selection_status == "selected_on_map" 
                                        ? e1.selection_status 
                                        : "none" as "none"})
      s1.data_to_display.entities = entities.toList()
    }else{
      let selected_cat = s1.data_to_display.selected_category
      let categories1 = s1.data_to_display.categories.map(c => c.title == selected_cat 
        ? {...c, entities:c.entities.map(e1 => are_cord_same(e.position, e1.position) 
                                                  ? {...e1, selection_status:status} 
                                                  : status == "selected_in_list" || status == "selected_on_map" 
                                                    ? {...e1, selection_status:"none" as "none"}
                                                    : {...e1, selection_status: e1.selection_status == "selected_in_list" || 
                                                                                e1.selection_status == "selected_on_map" 
                                                      ? e1.selection_status 
                                                      : "none" as "none"}).toList()} 
        : c).toList()
      s1.data_to_display = {...s1.data_to_display, categories:categories1}
    }
    return s1 
  })
}

export const mk_icon = icon => new L.Icon({
  iconUrl: icon,
  iconRetinaUrl: icon,
  iconAnchor: [5, 55],
  popupAnchor: [10, -44],
  iconSize: [25, 55],
  shadowUrl: '',
  shadowSize: [68, 95],
  shadowAnchor: [20, 92],
})

export const markerIcon: L.Icon = mk_icon("data:image/svg+xml;charset=utf-8;base64,PHN2ZyBoZWlnaHQ9IjQwIiB2aWV3Qm94PSIwIDAgMzIgNDAiIHdpZHRoPSIzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Im0xNiA0MGMxMC42NjY2NjY3LTEwLjEwODk2MjcgMTYtMTguMTA4OTYyNyAxNi0yNCAwLTguODM2NTU2LTcuMTYzNDQ0LTE2LTE2LTE2cy0xNiA3LjE2MzQ0NC0xNiAxNmMwIDUuODkxMDM3MyA1LjMzMzMzMzMzIDEzLjg5MTAzNzMgMTYgMjR6IiBmaWxsPSIjMDA0MTdFIi8+PGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgZmlsbD0iI2ZmZiIgcj0iOCIvPjwvZz48L3N2Zz4=")
export const markerIconSelected: L.Icon = mk_icon("data:image/svg+xml;charset=utf-8;base64,PHN2ZyBoZWlnaHQ9IjQwIiB2aWV3Qm94PSIwIDAgMzIgNDAiIHdpZHRoPSIzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Im0xNiA0MGMxMC42NjY2NjY3LTEwLjEwODk2MjcgMTYtMTguMTA4OTYyNyAxNi0yNCAwLTguODM2NTU2LTcuMTYzNDQ0LTE2LTE2LTE2cy0xNiA3LjE2MzQ0NC0xNiAxNmMwIDUuODkxMDM3MyA1LjMzMzMzMzMzIDEzLjg5MTAzNzMgMTYgMjR6IiBmaWxsPSIjNmNhY2M3Ii8+PGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgZmlsbD0iI2ZmZiIgcj0iOCIvPjwvZz48L3N2Zz4=")
export const example_plus = mk_icon("data:image/svg+xml;charset=utf-8;base64,")

export function getDistance(origin:LatLngLiteral, destination:LatLngLiteral) {
  // return distance in meters
  var lon1 = toRadian(origin.lng),
      lat1 = toRadian(origin.lat),
      lon2 = toRadian(destination.lng),
      lat2 = toRadian(destination.lat);

  var deltaLat = lat2 - lat1;
  var deltaLon = lon2 - lon1;

  var a = Math.pow(Math.sin(deltaLat/2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(deltaLon/2), 2);
  var c = 2 * Math.asin(Math.sqrt(a));
  var EARTH_RADIUS = 6371;
  return c * EARTH_RADIUS * 1000;
}
function toRadian(degree) {
  return degree*Math.PI/180;
}


export let mocked_up_categories = Immutable.List<{title:string, entities:Immutable.List<MapEntity>}>(
    [
      {title:"Cat-A", entities:generateMapEntity(center_rotterdam, 2000, 50)},
      {title:"Cat-B", entities:generateMapEntity(center_rotterdam, 3000, 50)},
      {title:"Cat-C", entities:generateMapEntity(center_rotterdam, 4000, 50)}
    ])

export let apply_layer = (provider_name, map) => {
  map.eachLayer(l => {
    if(l["_url"] != undefined)
      map.removeLayer(l)
  })
  L.tileLayer.provider(provider_name).addTo(map)
}
export let mocked_up_tile_provides = Immutable.List<{name:string, apply:(map:L.Map) => void}>([

  
  { name  : "OpenStreetMap.Mapnik",  apply : (map:L.Map) => { apply_layer('OpenStreetMap.Mapnik', map)} },
  { name  : "OpenTopoMap",  apply : (map:L.Map) => { apply_layer('OpenTopoMap', map)} },
  { name  : "OpenMapSurfer.Roads",  apply : (map:L.Map) => { apply_layer('OpenMapSurfer.Roads', map) } },
  { name  : "Stamen.TonerBackground",  apply : (map:L.Map) => { apply_layer('Stamen.TonerBackground', map) } },
  { name  : "Stamen.Watercolor",  apply : (map:L.Map) => { apply_layer('Stamen.Watercolor', map) } },
  { name  : "Stamen.Terrain",  apply : (map:L.Map) => { apply_layer('Stamen.Terrain', map) } },
  { name  : "Esri.WorldStreetMap",  apply : (map:L.Map) => { apply_layer('Esri.WorldStreetMap', map) } },
  { name  : "Esri.WorldTopoMap",  apply : (map:L.Map) => { apply_layer('Esri.WorldTopoMap', map) } },
  { name  : "MtbMap",  apply : (map:L.Map) => { apply_layer('MtbMap', map) } },
  { name  : "CartoDB.Positron",  apply : (map:L.Map) => { apply_layer('CartoDB.Positron', map) } },
  { name  : "Wikimedia",  apply : (map:L.Map) => { apply_layer('Wikimedia', map) } },
])

export let are_cord_same = (c1:L.LatLngLiteral, c2:L.LatLngLiteral) : boolean => {
  return c1.lat == c2.lat && c1.lng == c2.lng
}

export let sample_MapStyling : MapStyling = {
  root: "block block--map",
  root__inner: "block__inner container container--l grid--block",
  root__search: "map__search",
  root__search__label: "map__search-label",
  root__search__button: "map__search-clickable",
  root__search__icon: "map__search-icon",
  root__search__input: "map__search-input",
  root__switch: "map__switch",
  root__switch__item: "map__switch-item",
  root__list: "map__list",
  root__list__header: "map__list-header",
  root__list__title: "map__list-title",
  root__list__content: "map__list-content",
  root__list__item: "map__list-item",
  root__map: "map__map",
  root__map__actions: "map__actions",
  root__list__content__add_more_items: "map__add-more btn btn--primary",
  cluster_styling:(data:CategoriesList | SimpleList) => function (cluster) {

    var childCount:any = cluster.getChildCount();
    let children = cluster.getAllChildMarkers()
    let is_child_selected = children.find(c => (c.options as any).state && (c.options as any).state != "none")
    
    if(is_child_selected != undefined){
      childCount = "!"
    }
    var c = ' marker-cluster-';
    if (childCount < 5) {
      c += 'small';
    } 
    else if (childCount < 19) {
      c += 'medium';
    } 
    else {
      c += 'large';
    }
    children.forEach(c => {
      c.removeEventListener("onpopupclose")
      c.removeEventListener("onmouseover")
      c.removeEventListener("onmouseout")
      c.removeEventListener("onclick")
      
    })
   
    return new L.DivIcon({ html: '<div><span>' + childCount + '</span></div>', 
     className: 'marker-cluster' + c, iconSize: new L.Point(40, 40) });
  },
}

export let setQueryStringParameter = (name:string, value:string) => {
  // let history = useHistory();
  const params = new URLSearchParams(location.search);
  params.set(name, value);
  // history.push(decodeURIComponent(`${location.pathname}?${params}`));
  window.history.replaceState({}, "", decodeURIComponent(`${location.pathname}?${params}`));
}

export let update_params = function(s:MapsState, route_params: { param: string; value: string; }[][]) {
  let route_params1 = route_params.map(items => {
    if(items.find(i => i.param == "kind" && i.value == "map")){
      if(items.find(e => e.param == "city") == undefined){
        items = items.concat([{param:"city", value:""}])
      }
      // if(items.find(e => e.param == "zoom") == undefined){
      //   items = items.concat([{param:"zoom", value:""}])
      // }
      return items.map(item => {
        let zoom : number = undefined
        if(s.map == undefined) return item
        if(s.map != "none"){
          zoom = s.map.leafletElement.getZoom()
        }
        if(item.param == "city"){ 
          return {...item, value : s.search_status.value} 
        }
        // if(item.param == "zoom" && zoom){ 
        //   return {...item, value : `${zoom}`} 
        // }
        return item
      }).filter(i => i.param != "" && i.value != "")
    }
    else return items
  })
  return route_params1
}

export let params_to_string = (data:{ param: string; value: string; }[][]) :string => {
  let res = data.map(items => items.map(item => `${item.param}$${item.value}`).join("!")).join(";")
  return res
}


// WEBPACK FOOTER //
// ./Client/components/map/maps_utils.tsx